<app-profile-media-analyze-pro></app-profile-media-analyze-pro>

<app-profile-media-engage-pro></app-profile-media-engage-pro>


<section class="content">
  <div class="row">
    <div class="col-md-12">
      <app-profile-media-activity-chart></app-profile-media-activity-chart>
    </div>
  </div>
</section>

<section class="content">
  <h6 class="content-header">Profile activity by hours</h6>
  <div class="card">
    <div class="row m-0">
      <div class="col-md-6 card-body border-bottom border-right no-border-sm">
        <app-profile-media-hour-chart type="post_count" title="Posts"></app-profile-media-hour-chart>
      </div>
      <div class="col-md-6 card-body">
        <app-profile-media-hour-chart type="reach" title="Reach"></app-profile-media-hour-chart>
      </div>
    </div>
<!--    <div class="row m-0"> -->
<!--      <div class="col-md-6 card-body border-bottom no-border-sm">-->
<!--      <app-profile-media-hour-chart type="like" title="Likes by hours"></app-profile-media-hour-chart>-->
<!--    </div>-->
<!--      <div class="col-md-6 card-body border-right no-border-sm">-->
<!--        <app-profile-media-hour-chart type="comment" title="Comments by hours"></app-profile-media-hour-chart>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</section>

<section class="content">
  <h6 class="content-header">Profile activity by week days</h6>
  <div class="card">
    <div class="row m-0">
      <div class="col-md-6 card-body border-bottom border-right no-border-sm">
        <app-profile-media-week-day-chart type="post_count" title="Posts"></app-profile-media-week-day-chart>
      </div>
      <div class="col-md-6 card-body no-border-sm">
        <app-profile-media-week-day-chart type="reach" title="Reach"></app-profile-media-week-day-chart>
      </div>
    </div>
<!--    <div class="row m-0">-->
<!--      <div class="col-md-6 card-body border-bottom no-border-sm">-->
<!--        <app-profile-media-week-day-chart type="like" title="Likes by week days"></app-profile-media-week-day-chart>-->
<!--      </div>-->
<!--    </div>-->
<!--      <div class="col-md-6 card-body border-bottom border-right no-border-sm">-->
<!--        <app-profile-media-week-day-chart type="comment" title="Comments by week days"></app-profile-media-week-day-chart>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="row m-0">-->
<!--    <div class="col-md-6 card-body no-border-sm">-->
<!--        <app-profile-media-engage-week-day></app-profile-media-engage-week-day>-->
<!--    </div>-->
  </div>
</section>

<section class="content">
  <h6 class="content-header">Most used</h6>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <app-profile-media-word-rank></app-profile-media-word-rank>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="card">
        <div class="card-body">
          <app-profile-media-hashtag-rank></app-profile-media-hashtag-rank>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="card">
        <div class="card-body">
          <app-profile-media-tag-rank channelType="tiktok"></app-profile-media-tag-rank>
        </div>
      </div>
    </div>
  </div>
</section>
